/* eslint-disable */ 
import { URL } from '../../../config'
import { getRequest } from '../../../utils/functions/httpRequest'

export const getRankingsBySeason = function (seasonId,weekNo) 
{
    const endpoint = `/${seasonId}/${weekNo}/rankings`
    const rankingURL = `${URL.ranking}${endpoint}` 
    return getRequest(rankingURL)
} 
 


// WEBPACK FOOTER //
// ./src/components/pages/api/getRankingBySeason.js